<form [formGroup]="form">

  <h2 i18n>Internal Cable</h2>
  <div fxLayout="row">
    <div fxFlex="25">
      <mat-button-toggle-group formControlName="internalCable">
        <mat-button-toggle value="direct" i18n>DIRECT</mat-button-toggle>
        <mat-button-toggle value="indirect" i18n>INDIRECT</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div fxFlex="25">
      <mat-form-field appearance="outline" class="app-block">
        <mat-label i18n>Max Length</mat-label>
        <input type="number" #maxLength matInput formControlName="maxLengthCable">
      </mat-form-field>
      <div>
        <app-suggestion [input]="maxLength" [options]="[100, 150, 200]"
          (changeSelection)="this.form.patchValue({maxLengthCable: $event})">
        </app-suggestion>
      </div>
    </div>
  </div>


  <h2 i18n>Connection</h2>
  <div fxLayout="row" fxLayoutGap="16px">
    <div fxFlex="25">
      <h4>OLT - DGO</h4>
      <mat-button-toggle-group value="patch_cord">
        <mat-button-toggle value="patch_cord" i18n>PATCH CORD</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div fxFlex="50">
      <h4 i18n>DGO - Internal Cable</h4>
      <mat-button-toggle-group formControlName="connectionDgoInternalCable">
        <mat-button-toggle value="connectorized_cable" i18n>CONN CABLE</mat-button-toggle>
        <mat-button-toggle value="pig_tail" i18n>PIG TAIL</mat-button-toggle>
        <mat-button-toggle value="field_connector" i18n>FIELD</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div fxFlex="25">
      <h4 i18n>Internal Cable - Splice Box</h4>
      <mat-button-toggle-group value="fusion">
        <mat-button-toggle value="fusion" i18n>FUSION</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>

</form>
